import { Container, Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { FaCircleCheck } from "react-icons/fa6";
import LoginPage from "./LoginPage";

export default function AuthPage({ status }) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md={7} className="p-0">
            <div
              className="d-flex justify-content-center align-items-center border-end"
              style={{
                height: "100vh",
                background: "linear-gradient(135deg, #4c8cff, #4c8cff, #4c8bff54)",
                color: "white",
                padding: "40px",
              }}
            >
              <div>
                <motion.h3 className="text-center mb-4 fw-bold">
                  Password Manager [PM]
                </motion.h3>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="p-4 rounded-4 shadow-lg"
                  style={{
                    backdropFilter: "blur(12px)",
                    background: "rgba(255, 255, 255, 0.15)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    // maxWidth: "470px",
                  }}
                >
                  <motion.h3
                    className="text-center mb-4 fw-bold"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    style={{ fontSize: "1.5rem" }}
                  >
                    Try Password Manager free for 1 year
                  </motion.h3>

                  <motion.ul
                    className="list-unstyled"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    style={{ lineHeight: "2rem", fontSize: "1.05rem" }}
                  >
                    <li><FaCircleCheck className="text-light me-2" /> 1 personal account with unlimited devices</li>
                    <li><FaCircleCheck className="text-light me-2" /> Advanced security with authenticated encryption, PAKE, and more</li>
                    <li><FaCircleCheck className="text-light me-2" /> Alerts for compromised websites and vulnerable passwords</li>
                    <li><FaCircleCheck className="text-light me-2" /> 24/7 customer support</li>
                    <li><FaCircleCheck className="text-light me-2" /> Works on Mac, iOS, Windows, Android & Linux</li>
                  </motion.ul>

                  <motion.div
                    animate={{ y: [0, -10, 0] }}
                    transition={{ duration: 3, repeat: Infinity }}
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.25)",
                    }}
                  />

                  <motion.div
                    animate={{ y: [0, 10, 0] }}
                    transition={{ duration: 4, repeat: Infinity }}
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "20px",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.15)",
                    }}
                  />

                </motion.div>
                <div className="text-center py-3">
                  <motion.span className="text-center" style={{ fontSize: 12 }}>
                    © {new Date().getFullYear()} Password Manager [PM]. All rights reserved. <br />
                    Bengaluru, Karnataka, India.
                  </motion.span>
                </div>
              </div>
            </div>

          </Col>

          <Col md={5} className="p-0">
            <div className="hstack justify-content-center" style={{ height: "100vh" }}>
              <AnimatePresence mode="wait">
                <LoginPage />
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
